import { memo } from 'react';

import type { SVGProps } from 'react';
const SvgImageCustodian = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 22 24"
    role="img"
    className={props.className}
    {...props}
  >
    <path
      fill="#0B6BA2"
      d="M.346 13.994V2.15c0-1 .821-1.81 1.835-1.81h16.975c1.013 0 1.835.81 1.835 1.81v11.844a6.77 6.77 0 0 1-3.243 5.765l-6.11 3.757a1.86 1.86 0 0 1-1.94 0l-6.11-3.757a6.77 6.77 0 0 1-3.242-5.765"
    />
    <path
      fill="#005A8E"
      d="M19.154.34c1.014 0 1.836.81 1.836 1.81v11.844a6.78 6.78 0 0 1-3.243 5.765l-6.11 3.757a1.85 1.85 0 0 1-.971.274V.34z"
    />
    <path
      fill="#0B6BA2"
      fillRule="evenodd"
      d="M2.18.676C1.355.676.687 1.33.687 2.139v11.78a6.39 6.39 0 0 0 3.08 5.447l6.11 3.737a1.52 1.52 0 0 0 1.577 0l6.11-3.737a6.39 6.39 0 0 0 3.08-5.447V2.139c0-.808-.667-1.463-1.49-1.463zM0 2.139C0 .958.976 0 2.18 0h16.974c1.204 0 2.18.958 2.18 2.14v11.779c0 2.449-1.288 4.725-3.405 6.02l-6.11 3.737c-.705.432-1.6.432-2.305 0l-6.11-3.737C1.288 18.644 0 16.368 0 13.92z"
      clipRule="evenodd"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M5.791 8.292V7.208a1.083 1.083 0 0 1 1.083-1.083h1.084m5.416 0h1.084a1.083 1.083 0 0 1 1.083 1.083v1.084m0 5.416v1.084a1.083 1.083 0 0 1-1.083 1.083h-1.084m-5.416 0H6.874a1.083 1.083 0 0 1-1.083-1.083v-1.084M11.208 11a.542.542 0 1 1-1.084 0 .542.542 0 0 1 1.084 0m-4.334 0s1.355-2.708 3.792-2.708c2.438 0 3.792 2.708 3.792 2.708s-1.354 2.708-3.792 2.708S6.874 11 6.874 11"
    />
  </svg>
);
const Memo = memo(SvgImageCustodian);
export default Memo;
